<template>
  <v-container id="login">
    <v-form ref="form" @submit.prevent="onSubmit">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-img min-height="100" src="@/assets/image/Nekologic.png" />
          <br />
          <v-card color="secondary" elevation="24" class="mx-0 px-5">
            <h1 class="login_header">LOGIN TO NEKOHR</h1>
            <v-alert show border="left" v-if="status">{{
              status.message
            }}</v-alert>
            <v-text-field
              v-model="username"
              required
              :error-messages="usernameErrors"
              placeholder="Enter your Username or Email Address"
              type="text"
              background-color="white"
              color="red"
              @input="$v.username.$touch()"
              @blur="$v.username.$touch()"
              solo
            >
              <v-icon slot="prepend" color="yellow">mdi-account </v-icon>
            </v-text-field>
            <v-text-field
              v-model="password"
              required
              :error-messages="passwordErrors"
              placeholder="Enter your Password"
              type="password"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              solo
              background-color="white"
              color="red"
            >
              <v-icon slot="prepend" color="yellow"
                >mdi-account-key
              </v-icon></v-text-field
            >
            <br />
            <v-row align="center" class="large_screen" justify="space-around">
              <v-btn type="submit" class="btn" tile large color="yellow"
                >Login</v-btn
              >
              <v-btn
                class="btn"
                tile
                large
                color="primary"
                @click="forgotPassword"
                >Forgot Password</v-btn
              >
            </v-row>
            <v-row align="center" class="small_screen" justify="space-around">
              <v-btn class="btn" type="submit" tile small color="yellow"
                >Login</v-btn
              >
              <v-btn
                class="btn"
                tile
                small
                color="primary"
                @click="forgotPassword"
                >Forgot Password</v-btn
              >
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    username: {required},
    password: {required},
  },
  data() {
    return {
      username: "",
      status: {
        message: "",
        enable: false,
      },
      name: "",
      email: "",
      password: "",
    };
  },
  computed: {
    ...mapGetters([]),
    passwordErrors() {
      const errors = [];
      if (this.$v.password.$dirty) {
        !this.$v.password.required && errors.push("Password is required");
      }
      return errors;
    },
    usernameErrors() {
      const errors = [];
      if (this.$v.username.$dirty) {
        !this.$v.username.required && errors.push("Username is required.");
      }
      return errors;
    },
  },
  mounted() {
    this.status = "";
    this.AUTH_LOGOUT_REQUEST();
  },
  methods: {
    ...mapActions([
      "AUTH_REQUEST",
      "showLoadingProcess",
      "closeLoading",
      "AUTH_LOGOUT_REQUEST",
    ]),
    onSubmit() {
      this.$v.$touch();
      /* Checks if form is valid then make api request. */
      if (!this.$v.$invalid) {
        this.login();
      }
    },
    async login() {
      const {username, password} = this;
      await this.showLoadingProcess();
      try {
        await this.AUTH_REQUEST({username, password});
        this.status = {
          type: "success",
          message: "Login Successful!!!!",
        };
        await this.closeLoading();
        await this.$router.push({name: "Home"});
      } catch (err) {
        await this.closeLoading();
        let tempStatus = {
          type: "danger",
          message: "Unknown Error, please try again later!",
        };
        if (err.message === "Network Error") {
          tempStatus.message = "Network connection Error";
        } else {
          const res = err.response.data;
          if (res.username !== undefined || res.email !== undefined) {
            tempStatus.message = "Fields Cannot be Empty";
          } else if (res.non_field_errors !== undefined) {
            tempStatus.message = res.non_field_errors[0];
          }
        }
        this.status = tempStatus;
      }
    },
    register() {
      this.$router.push("/register");
    },
    forgotPassword() {
      this.$router.push("/forgot_password");
    },
  },
};
</script>

<style scoped>
.large_screen {
  padding-inline: 33%;
}
.small_screen {
  display: none;
}
.btn {
  width: 100%;
  margin-bottom: 10px;
}

.login_header {
  color: yellow;
  font-weight: bold;
  margin: 20px;
  text-align: center;
}

@media only screen and (max-width: 440px) {
  .large_screen {
    display: none;
  }
  .small_screen {
    display: flex;
  }
}
</style>
